import type { LabTurn, LabTurnDiff } from "@/lib/labModel";
import type { LabRunModel } from "@/lib/labRunModel";

import {
  ClassificationItem,
  NOTHING,
  ResolvedRefs,
  Section,
} from "./LabTurnSummary";

/**
 * Classification tab: each classifier's result and rationale (bodies only
 * after the existing explicit Show press), its score as recorded or stated as
 * absent, and every input reference resolved to what it points at.
 */
export function LabClassificationTab({
  projectId,
  previewRunRef,
  turn,
  model,
  onSelectTurn,
  diff = null,
}: {
  projectId: string;
  previewRunRef: string;
  turn: LabTurn;
  model: LabRunModel;
  onSelectTurn: (turn: number) => void;
  /** Compare mode: the axes on which the two runs differ at this turn. */
  diff?: LabTurnDiff | null;
}) {
  return (
    <Section title="Classification" differs={diff?.classification === true}>
      {turn.classifications.length === 0
        ? NOTHING
        : turn.classifications.map((event) => (
            <ClassificationItem
              key={event.eventRef}
              projectId={projectId}
              runRef={previewRunRef}
              event={event}
              scoreState
            >
              <ResolvedRefs
                label="Input references"
                refs={event.detail.inputRefs}
                citingEventRef={event.eventRef}
                field="inputRefs"
                model={model}
                projectId={projectId}
                previewRunRef={previewRunRef}
                onSelectTurn={onSelectTurn}
              />
            </ClassificationItem>
          ))}
    </Section>
  );
}
